var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.978 9.76 9.632-5.827a4.51 4.51 0 0 1 .26-.106l.003-.001a1.958 1.958 0 0 1 .296.096l9.328 6.046c.034.124.068.256.095.366l-1.085 17.838H6.873l-1.06-17.995a2.547 2.547 0 0 1 .03-.324 1.07 1.07 0 0 1 .062-.046l.042-.028v-.001l.016-.01.015-.01zm-.115.004zm9.41-8.695c.084-.022.3-.076.554-.07.71.01 1.402.305 1.651.43l.07.035.066.043 9.477 6.142c.17.105.356.254.525.439.178.192.406.497.53.908.096.324.196.733.233.896l.046.198-.012.203-1.117 18.355c.02.225.01.497-.073.779-.129.44-.465.979-1.14 1.224-.355.13-.729.239-.883.28l-.183.05H6.976a2.462 2.462 0 0 1-1.854-.571c-.467-.39-.8-.837-.944-1.22l-.075-.199-.013-.212-1.09-18.49-.002-.04v-.042c0-.17.012-.418.048-.68.032-.228.1-.615.276-.968.192-.384.48-.663.664-.822.193-.167.392-.303.546-.392l9.69-5.863.063-.039.067-.031a7.08 7.08 0 0 1 .554-.23c.105-.04.233-.082.365-.116zm3.897 13.534h3.304V11.51L15.76 7.329 8.976 11.51l.562 7.242h9.14l-.176 3.128h-5.449l-.246-2.284H9.538l.352 5.659H21.7l.774-9.878H12.63v-2.109l3.13-1.968 3.41 1.968v1.336z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtk);
export default __webpack_public_path__ + "static/media/CTK.276eece72048ebf8829e8e507f784d96.svg";
export { ForwardRef as ReactComponent };